import Storage from './index';
const layoutStorage = new Storage("app.layout");
export default layoutStorage;
